import { Modal } from "antd";
import { UiDrawer, UiProfileModel, UiTable, UiWarningRating } from "../../components";
import { formatPhoneNumber } from "../../utils/appUtils";
import "./style.scss";

const EditHistory = ({ isOpen, handleEditHistoryClose, editHistoryData, selectedLawyerName, selectedLawyerProfile, editHistoryColumns, selectedHistoryDetail, editableRequestFields, handleEditHistoryModalClose }) => {
    const currentLawyerDetail = selectedHistoryDetail?.currentLawyerDetail || {};
    const getDisplayValue = (value) => {
        if (Array.isArray(value)) {
            return value?.length > 0 ? value?.join(", ") : "Nil";
        }
        return value || value === 0 ? `${value}` : "Nil";
    };

    const changedKeyValueRows = editableRequestFields
        ?.map((fieldName) => ({
            field: fieldName,
            currentValue: getDisplayValue(currentLawyerDetail?.[fieldName]),
            editedValue: getDisplayValue(selectedHistoryDetail?.[fieldName])
        }))
        ?.filter((detail) => detail?.currentValue !== detail?.editedValue);

    return <>
        <UiDrawer
            title="Edited History"
            open={isOpen}
            onClose={handleEditHistoryClose}
            width={600}
        >
            <div className="lawyer-information" style={{ marginBottom: "12px" }}>
                <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                    <div className="flexible">
                        <UiProfileModel imageUrl={selectedLawyerProfile?.profilePic} />
                        <div style={{ padding: "5px 10px" }}>
                            <h3 className="lawerInfo-detail">{selectedLawyerProfile?.name || selectedLawyerName || "Nil"}</h3>
                            <UiWarningRating count={selectedLawyerProfile?.warningCountAfterActive || 0} />
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Advocate ID</small>
                            <h3 className="lawerInfo-detail">{selectedLawyerProfile?.lawyerId || "Nil"}</h3>
                        </div>
                    </div>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail">{selectedLawyerProfile?.mobileNumber ? formatPhoneNumber(selectedLawyerProfile?.mobileNumber) : "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h3 className="lawerInfo-detail">{selectedLawyerProfile?.email || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <UiTable
                columns={editHistoryColumns}
                dataSource={editHistoryData}
                pagination={false}
                locale={{ emptyText: "No edit history found" }}
            />
        </UiDrawer>
        <Modal
            open={Boolean(selectedHistoryDetail)}
            onCancel={handleEditHistoryModalClose}
            footer={null}
            title="Changed Details"
            width={650}
        >
            <div style={{ marginTop: "12px", border: "1px solid #f0f0f0", borderRadius: "8px", overflow: "hidden" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px", padding: "10px 12px", backgroundColor: "#f7f7f7", borderBottom: "1px solid #ececec" }}>
                    <span style={{ fontWeight: 600 }}>Field</span>
                    <span style={{ fontWeight: 600 }}>Current</span>
                    <span style={{ fontWeight: 600, textAlign: "right" }}>Changed</span>
                </div>
                {changedKeyValueRows?.map((changeDetail, index) => (
                    <div
                        key={`${changeDetail?.field}-${index}`}
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gap: "12px",
                            padding: "10px 12px",
                            borderBottom: index === changedKeyValueRows?.length - 1 ? "none" : "1px solid #f5f5f5",
                            backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa"
                        }}
                    >
                        <span>{changeDetail?.field}</span>
                        <span>{changeDetail?.currentValue}</span>
                        <span style={{ textAlign: "right" }}>{changeDetail?.editedValue}</span>
                    </div>
                ))}
            </div>
        </Modal>
    </>
};

export default EditHistory;